module.exports = __webpack_public_path__ + "img/h.d0aa6c0b.jpg";